import { from } from "rxjs";
import { selectBuffedXpFromProjectInfo } from "../../../selectors/selectCoopInfo";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionCoopInfoAddXp, actionCoopProjectInfoReceived } from "../../cooperative/actionCoop";
import { actionPlayerLeagueInfoAddPoints } from "../../info/league/actionPlayerLeagueInfo";
export var networkNoticeProjectInfoHandler = function (action$, state$, deps) { return function (res) {
    var actions = [];
    if (res.project && res.project.typeId && res.project.difficulty && res.project.completed) {
        var totalPoints = selectBuffedXpFromProjectInfo(state$.value, res.project.typeId, res.project.difficulty - 1);
        actions.push(actionCoopInfoAddXp(totalPoints));
        actions.push(actionPlayerLeagueInfoAddPoints(totalPoints, EventType.CoopLeague));
    }
    actions.push(actionCoopProjectInfoReceived(res));
    return from(actions.slice());
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeProjectInfoHandler.ts
// module id = 2020
// module chunks = 3